import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';

// `amazon-cognito-identity-js` reaches for Buffer/global; provide them.
(globalThis as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App.js';
import { BlurProvider } from './app/BlurContext.js';
import { ThemeProvider } from './app/ThemeContext.js';
import { AuthProvider } from './auth/AuthContext.js';
import { InfraProviderRoot } from './infra/context.js';
import './app/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element missing');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <BlurProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <InfraProviderRoot>
              <AuthProvider>
                <App />
              </AuthProvider>
            </InfraProviderRoot>
          </BrowserRouter>
        </QueryClientProvider>
      </BlurProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
